import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ROLES } from "./roles";
import { getDashboardRoute } from "./authHelpers";

export default function PrivateRoute({ children, roles = [] }) {
  const { user } = useAuth();
  const { slug } = useParams();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/login" replace />;
  }

  // Le SUPER_ADMIN n'est rattaché à aucun établissement : rien à vérifier.
  // Pour tous les autres, la route contient un slug (/:slug/admin/..., etc.)
  // qui DOIT correspondre à l'établissement de l'utilisateur — sinon un
  // administrateur de l'École A pourrait naviguer manuellement vers
  // /ecole-b/admin/dashboard en changeant l'URL.
  if (
    user.role !== ROLES.SUPER_ADMIN &&
    slug &&
    slug !== user.etablissement_slug
  ) {
    return (
      <Navigate
        to={getDashboardRoute(user.role, user.etablissement_slug)}
        replace
      />
    );
  }

  return children;
}
